"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_TYPE_YEAR = exports.INPUT_TYPE_MONTH = exports.INPUT_TYPE_DAY = exports.EVENT_TYPE_CHANGE = exports.EVENT_TYPE_BLUR = void 0;
const INPUT_TYPE_MONTH = exports.INPUT_TYPE_MONTH = 'MONTH';
const INPUT_TYPE_DAY = exports.INPUT_TYPE_DAY = 'DAY';
const INPUT_TYPE_YEAR = exports.INPUT_TYPE_YEAR = 'YEAR';
const EVENT_TYPE_CHANGE = exports.EVENT_TYPE_CHANGE = 'CHANGE';
const EVENT_TYPE_BLUR = exports.EVENT_TYPE_BLUR = 'BLUR';